export default __webpack_public_path__ + "static/media/gaderobe.fe041b3e.jpg";